import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_RESOURCE_LIST, MANAGE_RESOURCE_ADD, MANAGE_RESOURCE_DELETE, LIST_REPORTS, DIAGNOSIS_SERVERITY_LIST, LIST_CLIENT_DETAILS_REPORTS, FAVOURITE_REPORT, CLINICAL_PRESENTATIONS_LIST, CLINICAL_IMPRESSIONS_LIST, } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const resourceApi = createApi({
    reducerPath: 'resourceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/resource",
    }),
    tagTypes: ["ResourceList"],
    endpoints: (builder) => ({

        // get resource list
        getResourceList: builder.query({
            query: ({ search = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_RESOURCE_LIST,
                    data: { search, page, limit, sort, }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ResourceList"]
        }),

        // Delete Resource
        deleteResource: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_RESOURCE_DELETE}/${id}`
            }),
            invalidatesTags: ["ResourceList"]
        }),

        // add Resource
        addResource: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_RESOURCE_ADD,
                data
            }),
            invalidatesTags: ["ResourceList"]
        }),

        getClientReportsList: builder.query({
            query: ({ search = "", page = 1, limit = 10, attachment_name, id, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: `${LIST_REPORTS}/${id}`,
                    data: { search, page, limit, sort, attachment_name }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),

        getDiagnosisList: builder.query({
            query: ({ search = "", page = 1, limit = 10, id, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: `${DIAGNOSIS_SERVERITY_LIST}/${id}`,
                    data: { search, page, limit, sort }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),

        getClientDetailReportsList: builder.query({
            query: ({ search = "", page = 1, limit = 10, status = "", attachment_name, id, published = false, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: `${LIST_CLIENT_DETAILS_REPORTS}/${id}`,
                    data: { search, page, limit, sort, attachment_name, published, status: status?.value }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),

        favouriteReport: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_REPORT}/${id}`,
                data
            }),
            invalidatesTags: ["reportsList"]
        }),

        getClinicalPresentationsList: builder.query({
            query: ({ search = "", page = 1, limit = 10, id, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "GET",
                    url: `${CLINICAL_PRESENTATIONS_LIST}/${id}`,
                    data: { search, page, limit, sort }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),

        getClinicalImpressionsList: builder.query({
            query: ({ search = "", page = 1, limit = 10, id, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "GET",
                    url: `${CLINICAL_IMPRESSIONS_LIST}/${id}`,
                    data: { search, page, limit, sort }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["reportsList"]
        }),

    }),
})

export const {
    useGetResourceListQuery,
    useDeleteResourceMutation,
    useAddResourceMutation,
    useGetClientReportsListQuery,
    useGetDiagnosisListQuery,
    useGetClientDetailReportsListQuery,
    useFavouriteReportMutation,
    useGetClinicalPresentationsListQuery,
    useGetClinicalImpressionsListQuery
} = resourceApi;